export default function () {
  return {
    notificationRequestUrls: [],
  };
}
